import { connect } from 'react-redux';
import AddExternalID from './AddExternalID';

const mapStateToProps = state => ({
  userGroup: state.userGroups.details.userGroup,
  filters: state.userGroups.list.filters,
});

export default connect(mapStateToProps, null)(AddExternalID);
